import React from 'react';

export default function StampsTable({ stamps, onViewDetails }) {
  const getStatusBadge = (stamp) => {
    if (stamp.used) {
      return <span className="badge success">✅ Used</span>;
    } else if (stamp.purchased) {
      return <span className="badge success">✅ Paid</span>;
    } else {
      return <span className="badge warning">⏳ Unpaid</span>;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Status</th>
            <th>Customer</th>
            <th>Address</th>
            <th>Email</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {stamps.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: 'center', padding: '40px' }}>
                No stamps found
              </td>
            </tr>
          ) : (
            stamps.map((stamp) => (
              <tr key={stamp.code}>
                <td><code style={{ color: 'var(--blue)' }}>{stamp.code}</code></td>
                <td>{getStatusBadge(stamp)}</td>
                <td>{stamp.user_name || '—'}</td>
                <td>{stamp.user_address || '—'}</td>
                <td>{stamp.user_email || '—'}</td>
                <td>{formatDate(stamp.purchased_at || stamp.reserved_at)}</td>
                <td>
                  {stamp.purchased && (
                    <button 
                      className="btn btn-secondary" 
                      style={{ padding: '6px 12px', fontSize: '12px' }}
                      onClick={() => onViewDetails && onViewDetails(stamp)}
                    >
                      View
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
